import { HSAL0226CollGroupId } from "respondent_config_generator/src/projects/HSAL-0226";
import { PlatformInstructionsKey } from "../../LandingPage/Components/Steps/LoginAndCompletionCode";
import { LandingPageConfigBuilder } from "../../LandingPage/landingPageConfigBuilder";
import { CAIParams } from "../../queryParams";
import { setCurrentLang } from "../../i18n";
import { AppLanguage, getLanguageStrings } from "internationalisation";

const getPlatform = (groupId: HSAL0226CollGroupId): PlatformInstructionsKey => {
	switch (groupId) {
		case "HSAL-465-0226-UK-FACEBOOK": return "facebook";
		case "HSAL-466-0226-UK-INSTAGRAM": return "instagram";
		case "HSAL-467-0226-UK-TIKTOK": return "tiktok";
		case "HSAL-468-0226-UK-SNAP": return "snapchat";
		case "HSAL-469-0226-UK-X": return "x";

		default: assertNever(groupId);
	}
}

export const configureHSAL0226Page = (
	landingPageBuilder: LandingPageConfigBuilder,
	params: CAIParams<HSAL0226CollGroupId>
) => {
	setCurrentLang(AppLanguage.en);

	landingPageBuilder.setSteps(
		LandingPageConfigBuilder.getStandardViewingSurveySteps(
			getPlatform(params.G)
		)
	);

	landingPageBuilder.setPageTitle(
		getLanguageStrings(AppLanguage.en).LandingPage.Title
	);
}